import * as React from 'react';
import { ChartTooltip } from 'common/components/chart-tooltip';
import { commaizeNumber, formatMetricNumber } from 'common/util';
import { formatConciseDuration } from 'common/util/date';
import { SankeyBreakdown } from './models/sanky-breakdown';
import { SankeyEdge } from './models/sankey-edge';
export const LinkTooltip = (props: {
  breakdown: SankeyBreakdown;
  edge: SankeyEdge;
  clientX: number;
  clientY: number;
  renameEvents: (name: string) => string;
}) => {
  const breakdown = props.breakdown;
  const edge = props.edge;
  const count = breakdown ? breakdown.totalCount : edge.totalCount;
  const percentage = formatMetricNumber(count / edge.fromNode.totalCount * 100);
  const fromCount = commaizeNumber(edge.fromNode.totalCount);
  const edgeCount = commaizeNumber(count);
  return <ChartTooltip positioning={{
    clientX: props.clientX,
    clientY: props.clientY
  }} data-sentry-element="ChartTooltip" data-sentry-component="LinkTooltip" data-sentry-source-file="link-tooltip.tsx">
      <div className={"sankey-tooltip"} key='sankey-tooltip'>
        <div className={"sankey-link-tooltip-path-container"}>
          <div className={"sankey-link-tooltip-node-container"}>
            <span>{props.renameEvents(edge.fromNode.eventString)}</span>
            <div className={"sankey-link-tooltip-node-connector"} />
          </div>
          <div className={"sankey-link-tooltip-node-container"}>
            <span>{props.renameEvents(edge.toNode.eventString)}</span>
          </div>
        </div>
        <div className={"sankey-link-tooltip-weight"}>
          {edgeCount} of {fromCount} {percentage}%
        </div>
        {breakdown && breakdown.timePercentilesFromStart.length > 0 && <div className={"sankey-link-tooltip-weight"}>
            Median time from start {formatConciseDuration(breakdown.timePercentilesFromStart[0])}
          </div>}
        {breakdown && breakdown.timePercentilesFromPrev.length > 0 && <div className={"sankey-link-tooltip-weight"}>
            Median time from previous step {formatConciseDuration(breakdown.timePercentilesFromPrev[0])}
          </div>}
      </div>
    </ChartTooltip>;
};